import axios from "axios";

const endpointUrl = "/campaignV2/customer/instantWin/cardDetailList";

const getInstantWinCardDetailList = async (productId) => {
  const { data: { data = {} } } = await axios.get(endpointUrl, {
    params: { product_id: productId }
  });
  const rows = Array.isArray(data.data) ? data.data : [];
  return rows;
};

export default getInstantWinCardDetailList;